<template>
  <div class="right-content">
    <div class="right-content-sell">
      <ul>
        <li @click="priceClick(info.sellPrice1)">
          <span>卖1</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.sellPrice1)
                ? 'stock-list-red'
                : Number(Number(info.preclose_px)) > Number(info.sellPrice1)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.sellPrice1 == 0
                ? "--"
                : info.sellPrice1
                ? info.sellPrice1
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.sellVolume1 == 0
              ? "--"
              : info.sellVolume1
              ? info.sellVolume1
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.sellPrice2)">
          <span>卖2</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.sellPrice2)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.sellPrice2)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.sellPrice2 == 0
                ? "--"
                : info.sellPrice2
                ? info.sellPrice2
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.sellVolume2 == 0
              ? "--"
              : info.sellVolume2
              ? info.sellVolume2
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.sellPrice3)">
          <span>卖3</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.sellPrice3)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.sellPrice3)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.sellPrice3 == 0
                ? "--"
                : info.sellPrice3
                ? info.sellPrice3
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.sellVolume3 == 0
              ? "--"
              : info.sellVolume3
              ? info.sellVolume3
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.sellPrice4)">
          <span>卖4</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.sellPrice4)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.sellPrice4)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.sellPrice4 == 0
                ? "--"
                : info.sellPrice4
                ? info.sellPrice4
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.sellVolume4 == 0
              ? "--"
              : info.sellVolume4
              ? info.sellVolume4
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.sellPrice5)">
          <span>卖5</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.sellPrice5)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.sellPrice5)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.sellPrice5 == 0
                ? "--"
                : info.sellPrice5
                ? info.sellPrice5
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.sellVolume5 == 0
              ? "--"
              : info.sellVolume5
              ? info.sellVolume5
              : "--"
          }}</span>
        </li>
      </ul>
    </div>
    <div class="right-content-price">
      <p>
        <span>现价</span
        ><span
          class="fsAr"
          :class="[
            Number(info.preclose_px) < Number(info.last_px)
              ? 'stock-list-red'
              : Number(info.preclose_px) > Number(info.last_px)
              ? 'stock-list-green'
              : 'stock-list-ccc',
          ]"
          >{{
            info.last_px == 0 ? "--" : info.last_px ? info.last_px : "--"
          }}</span
        >
      </p>
      <p>
        <span>涨幅</span
        ><span
          class="fsAr"
          :class="[
            Number(info.preclose_px) < Number(info.last_px)
              ? 'stock-list-red'
              : Number(info.preclose_px) > Number(info.last_px)
              ? 'stock-list-green'
              : 'stock-list-ccc',
          ]"
          >{{ info.px_change_rate ? info.px_change_rate + "%" : "--" }}</span
        >
      </p>
    </div>
    <div class="right-content-buy">
      <ul>
        <li @click="priceClick(info.buyPrice1)">
          <span>买1</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.buyPrice1)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.buyPrice1)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.buyPrice1 == 0
                ? "--"
                : info.buyPrice1
                ? info.buyPrice1
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.buyVolume1 == 0
              ? "--"
              : info.buyVolume1
              ? info.buyVolume1
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.buyPrice2)">
          <span>买2</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.buyPrice2)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.buyPrice2)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.buyPrice2 == 0
                ? "--"
                : info.buyPrice2
                ? info.buyPrice2
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.buyVolume2 == 0
              ? "--"
              : info.buyVolume2
              ? info.buyVolume2
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.buyPrice3)">
          <span>买3</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.buyPrice3)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.buyPrice3)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.buyPrice3 == 0
                ? "--"
                : info.buyPrice3
                ? info.buyPrice3
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.buyVolume3 == 0
              ? "--"
              : info.buyVolume3
              ? info.buyVolume3
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.buyPrice4)">
          <span>买4</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.buyPrice4)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.buyPrice4)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.buyPrice4 == 0
                ? "--"
                : info.buyPrice4
                ? info.buyPrice4
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.buyVolume4 == 0
              ? "--"
              : info.buyVolume4
              ? info.buyVolume4
              : "--"
          }}</span>
        </li>
        <li @click="priceClick(info.buyPrice5)">
          <span>买5</span>
          <span
            class="fsAr"
            :class="[
              Number(info.preclose_px) < Number(info.buyPrice5)
                ? 'stock-list-red'
                : Number(info.preclose_px) > Number(info.buyPrice5)
                ? 'stock-list-green'
                : 'stock-list-ccc',
            ]"
            >{{
              info.buyPrice5 == 0
                ? "--"
                : info.buyPrice5
                ? info.buyPrice5
                : "--"
            }}</span
          >
          <span class="fsAr">{{
            info.buyVolume5 == 0
              ? "--"
              : info.buyVolume5
              ? info.buyVolume5
              : "--"
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: Object,
  },
  // watch: {
  //   info: {
  //     deep: true,  // 深度监听
  //     handler(newVal,oldVal) {
  //        console.log(newVal,oldVal)
  //     }
  //   }
  // },
  created() {
    // console.log(this.info);
  },
  methods: {
    priceClick(value) {
      // console.log(this.info);
      console.log(this.info.preclose_px, this.info.sellPrice1);
      if (this.info.preclose_px < this.info.sellPrice1) {
        // console.log(111);
      } else {
        // console.log(222);
      }
      this.$emit("priceClick", value);
    },
  },
};
</script>

<style lang="less" scoped>
.fsAr {
  font-family: Arial, Helvetica, sans-serif;
  width: 1.02rem;
  // display: block;
  text-align: right;
}
.right-content {
  width: 2.8rem;
  height: 5rem;
  border: 1px solid #e5e5e5;
  font-size: 0.24rem;
  color: #282c38;
}
.right-content-sell {
  height: 2.24rem;
  ul {
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-around;
    li {
      padding: 0 0.12rem 0 0.16rem;
      display: flex;
      align-items: center;
      span {
        float: left;
      }
      span:nth-child(3) {
        float: right;
      }
      // justify-content: space-between;
    }
  }
}
.right-content-buy {
  height: 2.24rem;
  ul {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    li {
      padding: 0 0.12rem 0 0.16rem;
      display: flex;
      align-items: center;
      span {
        float: left;
      }
      span:nth-child(3) {
        float: right;
      }
      // justify-content: space-between;
    }
  }
}
.right-content-price {
  border-top: 0.01rem solid rgba(229, 229, 229, 1);
  border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
  height: 0.48rem;
  display: flex;
  align-items: center;
  //   justify-content: space-between;
  padding: 0 0 0 0.16rem;
  p {
    height: 0.48rem;
    font-size: 0.2rem;
    line-height: 0.48rem;
    width: 50%;
    display: flex;
    // justify-content: space-around;
    span {
      width: 0.6rem;
      -webkit-transform-origin-x: 0;
      -webkit-transform: scale(0.87);
    }
  }
}
.stock-list-red {
  color: #f44336;
}
.stock-list-green {
  color: #1aaa52;
}
.stock-list-333 {
  color: #333;
}
.stock-list-ccc {
  color: #666;
}
</style>